import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import commonCss from './CreativeAsset.css';
import PlayableHoverIndication, { IndicationType } from '../../../components/creatives/PlayableIndication';
import { IconSizes } from '../../../components/foundations/Icon';
import ImageAsset from './ImageAsset';

const PlayableAsset = React.forwardRef(({ url, onLoad, onError, showPlayable = true }, ref) => {
    const [isPreviewError, setIsPreviewError] = useState(false);

    useEffect(() => {
        onLoad && onLoad();
    }, [onLoad]);

    return (
        <div className={commonCss.playableContainer}>
            {!showPlayable ? (
                isPreviewError ? (
                    <PlayableHoverIndication
                        iconSize={IconSizes.X_LARGE}
                        ref={ref}
                        className={commonCss.playableIndication}
                        type={IndicationType.HOVER}
                    />
                ) : (
                    <ImageAsset
                        url={`${url}.thumb`}
                        onLoad={onLoad}
                        onError={() => {
                            setIsPreviewError(true);
                        }}
                    />
                )
            ) : (
                <>
                    <iframe
                        width="auto"
                        height="100%"
                        title={url}
                        src={url}
                        onErrorCapture={onError}
                        ref={ref}
                        onLoad={onLoad}
                        sandbox="allow-scripts"
                    />
                </>
            )}
        </div>
    );
});

PlayableAsset.propTypes = {
    url: PropTypes.string,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    showPlayable: PropTypes.bool,
};

export default PlayableAsset;
